module.exports = __webpack_public_path__ + "img/dataTypeSelected.1bc8890f.png";